import { useRoleLabels } from "../lib/RoleLabelsContext";
export const exerciseWaitingMessage = "Die Therapeutin oder der Therapeut bereitet die Übung vor …";

export function ExerciseWaitingCard({ className }: { className: string }) {
  const labels = useRoleLabels();
  return (
    <section className={className}>
      <div className="loading-card" role="status">{labels.THERAPIST.singular === "Therapeut:in" ? exerciseWaitingMessage : `Die Übung wird vorbereitet (${labels.THERAPIST.singular}) …`}</div>
    </section>
  );
}
